/* eslint-disable no-undef */
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import { globalHistory } from "@reach/router";

const reactPlugin = new ReactPlugin();

const ai = new ApplicationInsights({
  config: {
    instrumentationKey: window.location.origin.includes("localhost")
      ? ""
      : process.env.REACT_APP_INSTRUMENTAION_KEY,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: globalHistory },
    },
  },
});

try {
  ai.loadAppInsights();
} catch (err) {
  console.error("Application Insights failed to load:", err);
}

// Set authenticated user context if available
const loginUserName = sessionStorage.getItem("loginUserName");
if (loginUserName) {
  ai.setAuthenticatedUserContext(loginUserName.replace(/\s/g, ""));
}

export default (Component) => withAITracking(reactPlugin, Component);
export const appInsights = ai.appInsights;
